function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("title", null, "D9953346-A470-4088-8C35-EDDB314DE7C6");
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M28.3333333,5 L8.33333333,5 C6.48333333,5 5,6.5 5,8.33333333 L5,31.6666667 C5,33.5 6.48333333,35 8.33333333,35 L31.6666667,35 C33.5,35 35,33.5 35,31.6666667 L35,11.6666667 L28.3333333,5 L28.3333333,5 Z M20,31.6666667 C17.2333333,31.6666667 15,29.4333333 15,26.6666667 C15,23.9 17.2333333,21.6666667 20,21.6666667 C22.7666667,21.6666667 25,23.9 25,26.6666667 C25,29.4333333 22.7666667,31.6666667 20,31.6666667 L20,31.6666667 Z M25,15 L8.33333333,15 L8.33333333,8.33333333 L25,8.33333333 L25,15 L25,15 Z",
  id: "path-1"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "B2C-Membership*",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "WP1_B1_03_D_Membership-Type-Selector-Resume-application-popin",
  transform: "translate(-700.000000, -396.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Messaging/Modal/Time-out/Desktop",
  transform: "translate(425.000000, 344.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(263.000000, 40.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon/UI-Icons/ic_save",
  transform: "translate(12.000000, 12.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask"
}), /*#__PURE__*/React.createElement("g", {
  id: "Color/primary-purple",
  mask: "url(#mask-2)",
  fill: "#72246C"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-21.666667, -21.666667)",
  id: "Black"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 83.3333333,
  height: 83.3333333
}))))))));
const SvgIconSave = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40px",
  height: "40px",
  viewBox: "0 0 40 40",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconSave, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-save.b5982755.svg";
export { ForwardRef as ReactComponent };